import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styles from './DesktopMenuItem.scss';
import notifyAnalytics from '../notify-analytics';
import formatTestId from '../../../utils/test-id/format-testid';

const DesktopMenuItem = ({ label, url, children }) => {
  const [active, setActive] = useState(false);

  const handleOnClick = e => {
    if (!active && children) {
      e.preventDefault();
      setActive(true);
    } else {
      notifyAnalytics(label);
    }
  };

  return (
    <li
      className={styles.desktopMenuItem}
      onMouseEnter={() => setActive(true)}
      onMouseLeave={() => setActive(false)}
      data-testid={formatTestId(label, 'nav-')}
      data-active={active}
    >
      <a
        className={styles.desktopMenuItemLink}
        href={url}
        onClick={e => handleOnClick(e)}
      >
        {label}
      </a>
      {active && children}
    </li>
  );
};

DesktopMenuItem.defaultProps = {
  children: undefined,
};

DesktopMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default DesktopMenuItem;
